<template>
  <div class="batch-samples-batch-confirmation">
    <div class="batch-samples-batch-confirmation-content">
      <div class="batch-samples-batch-confirmation-title">
        Deseja inserir todas ({{ amount }}) amostras no lote?
      </div>

      <div class="batch-samples-batch-confirmation-description">
        Ao continuar, a amostra será inserida no lote
        <b>{{ batch.batchIdentifier }}</b>
        .
      </div>
    </div>

    <footer class="batch-samples-batch-confirmation-footer">
      <md-button
        class="btn btn-nonenary"
        @click="handleCancel"
      >
        Cancelar
      </md-button>

      <md-button
        class="btn btn-primary"
        :disabled="isMoving"
        @click="handleContinue"
      >
        Continuar
      </md-button>
    </footer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import notify from '@/api/notification'
import batchService from '@/api/batch'

import { BATCH_SOURCE_SYSTEM_WS } from '@/enums'

export default {
  name: 'BatchSamplesBatchConfirmation',
  props: {
    sample: {
      required: true,
    },
    batch: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isMoving: false,
    }
  },
  computed: {
    ...mapGetters(['selectedSamples']),
    samplesToInsert() {
      return this.sample ? [this.sample] : this.selectedSamples
    },
    amount() {
      return this.samplesToInsert.length
    },
  },
  methods: {
    handleCancel() {
      this.$emit('cancel')
    },
    async handleContinue() {
      this.isMoving = true

      try {
        for await (const sample of this.samplesToInsert) {
          if (sample.batch_identifier) {
            if (sample.origem === 'LIS') {
              await batchService.removeSamplesFromWSBatchToMove(
                sample.bar_code,
                sample.batch_identifier,
                this.batch.batchIdentifier
              )
            } else {
              await batchService.removeSamplesFromBatch(sample.bar_code, sample.batch_id)
            }
          }
        }

        const payload = {
          batchIdentifier: this.batch.batchIdentifier,
          samples: this.samplesToInsert.map(sample => ({
            barcode: sample.bar_code,
          })),
        }

        if (this.batch.source === BATCH_SOURCE_SYSTEM_WS) {
          await batchService.insertSampleIntoWSBatch(payload)
        } else {
          await batchService.insertSampleIntoBatch(payload)
        }

        this.$emit('requestSamplesListUpdate')

        this.isMoving = false

        notify({
          title: 'Amostras loteadas com sucesso.',
        })

        this.$emit('close')
      } catch (error) {
        console.error('Error inserting samples into batch.', error)

        this.isMoving = false

        const errorData = error.response?.data
        const message =
          errorData?.type === 'validation' && errorData?.description
            ? errorData.description
            : 'Ocorreu um problema inesperado ao tentar adicionar ao lote.'

        notify({
          title: 'Erro:',
          message,
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.batch-samples-batch-confirmation {
  font-family: 'Exo 2', sans-serif;
  display: flex;
  flex-direction: column;
  gap: 2rem;

  &-content {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  &-title {
    font-weight: 700;
    font-size: 1.125rem;
  }

  &-description {
    font-weight: 400;
    font-size: 1rem;
    color: #666666;
  }

  &-footer {
    display: flex;
    gap: 1rem;

    .md-button {
      flex: 1;
    }
  }
}
</style>
